import { BaseButton } from "components/buttons/BaseButton";
import { useEffect, useRef, useCallback } from "react";
import { UseFormGetValues, UseFormSetValue, FieldPath } from "react-hook-form";
import { TagSelector } from "components/widgets/TagSelector";
import { useKeyPress } from "hooks/useKeyPress";
import { ISignUpFieldValues } from "../AuthSignUp";
import { ITag } from "services/types";
import classes from "./SignUpTopicsStep.module.scss";
import authPopupClasses from "./../AuthPopup.module.scss";
import { clsx } from "clsx";

interface IProps {
  setValue: UseFormSetValue<ISignUpFieldValues>;
  getValues: UseFormGetValues<ISignUpFieldValues>;
  disabled: boolean;
}

const SignUpTopicsStep = (props: IProps) => {
  const { setValue, getValues, disabled } = props;
  const enterPressed = useKeyPress("Enter");
  const submitRef: React.RefObject<HTMLButtonElement> = useRef(null);

  const handleChangeTags = useCallback((tags: ITag[]) => {
    const tagNames = tags.map(tag => tag.name);
    setValue<FieldPath<ISignUpFieldValues>>("tags", tagNames);
  }, [setValue]);

  useEffect(() => {
    if (enterPressed && submitRef && submitRef.current) {
      submitRef.current.click();
    }
  }, [enterPressed]);

  return (
    <div className={authPopupClasses.ContentContainer}>
      <div className={classes.Title}>Select your favourite tags:</div>

      <div className={classes.Tags}>
        <TagSelector onChange={handleChangeTags} defaultSelectedTags={getValues().tags || []} invertColor />
      </div>

      <div className={clsx(authPopupClasses.Footer, authPopupClasses.FooterFixed)}>
        <BaseButton type="submit" submitRef={submitRef} disabled={disabled}>Register</BaseButton>
      </div>
    </div>
  );
};

export default SignUpTopicsStep;
